import {
  DSBadge,
  DSCardWrapper,
} from "@components/design-system/molecules";
import {
  faLayerGroup,
  faTrash,
  faUsers,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TemplateGroupCard = ({
  group,
  onEdit,
  onDelete,
  isOwner = true,
  dataTestId,
}) => {
  const sortedTemplates = [...(group.templates || [])].sort(
    (a, b) => a.position - b.position,
  );

  const isShared =
    group.sharingType && group.sharingType !== "PRIVATE";

  return (
    <DSCardWrapper
      interactive={isOwner}
      variant="default"
      padding="p-md"
      onClick={isOwner ? () => onEdit(group) : undefined}
      dataTestId={dataTestId}
    >
      <div className="flex flex-row gap-sm items-start w-full">
        <FontAwesomeIcon
          icon={faLayerGroup}
          size="2x"
          className="text-brand mt-1 shrink-0"
        />
        <div className="flex flex-col w-full min-w-px">
          <div className="flex flex-row items-center mb-1">
            <span className="text-sm font-medium truncate flex-1 min-w-0">
              {group.name}
            </span>
            <div className="flex items-center gap-xs ml-2 shrink-0">
              {isShared && (
                <FontAwesomeIcon
                  icon={faUsers}
                  className="text-secondary"
                  size="sm"
                  title="Shared with team"
                  data-testid={`${dataTestId}-shared-icon`}
                />
              )}
              {isOwner && (
                <FontAwesomeIcon
                  className={
                    "text-red-500 hover:text-red-600 cursor-pointer"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(group);
                  }}
                  data-testid={`${dataTestId}-delete`}
                  icon={faTrash}
                />
              )}
            </div>
          </div>

          {isShared && !isOwner && group.user && (
            <p className="text-xs text-secondary mt-xs">
              Created by {group.user.firstName} {group.user.lastName}
            </p>
          )}

          <div className="flex flex-wrap gap-xs mt-xs">
            {sortedTemplates.map(({ autoTemplate, position }) =>
              autoTemplate ? (
                <DSBadge
                  key={autoTemplate.uuid}
                  variant={
                    autoTemplate.templateType === "SOAP"
                      ? "brand"
                      : "blue"
                  }
                  size="sm"
                  dataTestId={`${dataTestId}-template-${position}`}
                >
                  {autoTemplate.name}
                </DSBadge>
              ) : null,
            )}
          </div>
        </div>
      </div>
    </DSCardWrapper>
  );
};

export default TemplateGroupCard;
